var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 133.937,
    height: 129.981,
    viewBox: "0 0 133.937 129.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_4532",
    x: 0,
    y: 31.304,
    width: 86.466,
    height: 98.677,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_4534",
    x: 40,
    y: 0.716,
    width: 93.937,
    height: 93.513,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5644",
    "data-name": "Grupo 5644",
    transform: "translate(-783.135 -358.753)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 783.13, 358.75)",
    filter: "url(#Trazado_4532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4532-2",
    "data-name": "Trazado 4532",
    d: "M120.936,35.5H54.61a4.072,4.072,0,0,0-4.07,4.07v78.537a4.064,4.064,0,0,0,3.808,4.054,1.371,1.371,0,0,0,.262.016H69.579V107.7a4.072,4.072,0,0,1,4.07-4.07h28.059a4.071,4.071,0,0,1,4.07,4.07v14.473h15.158a4.071,4.071,0,0,0,4.07-4.07V39.571a4.071,4.071,0,0,0-4.07-4.07M74.594,88.249A1.96,1.96,0,0,1,72.64,90.2H68.253A1.959,1.959,0,0,1,66.3,88.249V83.862a1.959,1.959,0,0,1,1.953-1.953H72.64a1.96,1.96,0,0,1,1.954,1.953Zm0-18.544a1.959,1.959,0,0,1-1.954,1.954H68.253A1.958,1.958,0,0,1,66.3,69.7V65.319a1.959,1.959,0,0,1,1.953-1.954H72.64a1.961,1.961,0,0,1,1.954,1.954Zm0-17.738a1.954,1.954,0,0,1-1.954,1.954H68.253A1.952,1.952,0,0,1,66.3,51.967V47.59a1.959,1.959,0,0,1,1.953-1.954H72.64a1.96,1.96,0,0,1,1.954,1.954Zm17.24,36.282A1.96,1.96,0,0,1,89.881,90.2H85.494a1.96,1.96,0,0,1-1.954-1.954V83.862a1.96,1.96,0,0,1,1.954-1.953h4.387a1.959,1.959,0,0,1,1.953,1.953Zm0-18.544a1.959,1.959,0,0,1-1.953,1.954H85.494A1.959,1.959,0,0,1,83.54,69.7V65.319a1.961,1.961,0,0,1,1.954-1.954h4.387a1.96,1.96,0,0,1,1.953,1.954Zm0-17.738a1.953,1.953,0,0,1-1.953,1.954H85.494a1.954,1.954,0,0,1-1.954-1.954V47.59a1.96,1.96,0,0,1,1.954-1.954h4.387a1.96,1.96,0,0,1,1.953,1.954Zm17.242,36.282a1.96,1.96,0,0,1-1.954,1.954h-4.387a1.96,1.96,0,0,1-1.954-1.954V83.862a1.96,1.96,0,0,1,1.954-1.953h4.387a1.959,1.959,0,0,1,1.954,1.953Zm0-18.544a1.959,1.959,0,0,1-1.954,1.954h-4.387a1.959,1.959,0,0,1-1.954-1.954V65.319a1.961,1.961,0,0,1,1.954-1.954h4.387a1.96,1.96,0,0,1,1.954,1.954Zm0-17.738a1.953,1.953,0,0,1-1.954,1.954h-4.387a1.954,1.954,0,0,1-1.954-1.954V47.59a1.96,1.96,0,0,1,1.954-1.954h4.387a1.96,1.96,0,0,1,1.954,1.954Z",
    transform: "translate(-44.54 -1.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Elipse_32",
    "data-name": "Elipse 32",
    d: "M35,5A30.009,30.009,0,0,0,23.324,62.645,30.009,30.009,0,0,0,46.676,7.355,29.808,29.808,0,0,0,35,5m0-5A35,35,0,1,1,0,35,35,35,0,0,1,35,0Z",
    transform: "translate(825.145 358.753)",
    fill: "#ed92c8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 783.13, 358.75)",
    filter: "url(#Trazado_4534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4534-2",
    "data-name": "Trazado 4534",
    d: "M81.471,77.833,55.829,52.365a31.386,31.386,0,1,0-4.053,4.092L77.413,81.92a2.88,2.88,0,0,0,4.059-4.087M31.665,58.044a25.521,25.521,0,1,1,25.522-25.52,25.55,25.55,0,0,1-25.522,25.52",
    transform: "translate(45.62 2.47)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJde);
export default __webpack_public_path__ + "static/media/JDE.160788c4b20c6cd1f1e3d9a6efdf7a63.svg";
export { ForwardRef as ReactComponent };